import styled from 'styled-components';
import { gridGap, GridProps, margin, MarginProps } from 'styled-system';

export const Wrapper = styled.div`
  display: flex;
  justify-content: start;
`;

export const List = styled.ul<GridProps & MarginProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0;
  margin: 0;
  ${margin};
  ${gridGap};
`;
